module.exports = "/virtual-football-league/img/amblems/right/logos/REAL MALLORCA.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/REAL MALLORCA.png
// module id = 2222
// module chunks = 4